// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QwbAOW3qkQu8Un {
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  margin-right: -4px;
  margin-bottom: 4px;
  float: right;
  gap: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"members": `QwbAOW3qkQu8Un`
};
export default ___CSS_LOADER_EXPORT___;
